import type { CampaignChannel } from "src/layouts/Engagements/EngagementInterfaces";
import { CAMPAIGN_CHANNEL_OPTIONS } from "src/layouts/Engagements/Campaigns/CampaignSetup/CampaignSetupConstants";

const CREATE_MENU_KEY = "campaignDashboard.createMenu";

export const CHANNEL_QUESTION_KEY = "campaignFlow.aiWizard.channelQuestion";
export const WHATSAPP_MODE_QUESTION_KEY = `${CREATE_MENU_KEY}.whatsapp.prompt`;

export const WHATSAPP_MODES = [true, false];

export const CHANNEL_REPLY_OPTIONS: CampaignChannel[] = ["email", "whatsapp"];

const EMAIL_KEYWORDS = ["email", "e-mail", "البريد"];
const WHATSAPP_KEYWORDS = ["whatsapp", "واتساب"];
const QUESTION_MARKS = ["?", "؟"];

const includesAny = (text: string, keywords: string[]) =>
  keywords.some(keyword => text.includes(keyword));

export const isChannelQuestionReply = (replyText: string) => {
  const text = replyText.toLowerCase();
  return (
    includesAny(text, QUESTION_MARKS) &&
    includesAny(text, EMAIL_KEYWORDS) &&
    includesAny(text, WHATSAPP_KEYWORDS)
  );
};

export const getChannelLabelKey = (channel: CampaignChannel) =>
  CAMPAIGN_CHANNEL_OPTIONS.find(option => option.value === channel)?.labelKey ?? channel;

export const getWhatsAppModeLabelKey = (useAi: boolean) =>
  `${CREATE_MENU_KEY}.${useAi ? "withAi" : "withoutAi"}`;
